export default function NotesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M4.75783 17.101V6.63305C4.75783 6.11084 4.94773 5.66775 5.32752 5.30378C5.70731 4.93982 6.15831 4.75783 6.68053 4.75783H17.101C17.6233 4.75783 18.0703 4.94377 18.4422 5.31565C18.8141 5.68753 19 6.13458 19 6.65679V14.2526L14.2526 19H6.65679C6.13458 19 5.68753 18.8141 5.31565 18.4422C4.94377 18.0703 4.75783 17.6233 4.75783 17.101ZM0.0341812 4.04572C-0.0607666 3.52351 0.0420935 3.05273 0.342761 2.63338C0.643429 2.21402 1.05487 1.95687 1.57708 1.86193L11.8789 0.0341812C12.4011 -0.0607666 12.8719 0.0420935 13.2913 0.342761C13.7106 0.643429 13.9678 1.05487 14.0627 1.57708L14.3001 2.85888H12.3537L12.1875 1.9094L1.9094 3.73714L2.85888 9.10169V15.7243C2.60568 15.5819 2.3881 15.392 2.20611 15.1546C2.02413 14.9172 1.9094 14.6482 1.86193 14.3476L0.0341812 4.04572ZM6.65679 6.65679V17.101H13.3031L17.101 13.3031V6.65679H6.65679ZM10.9294 15.6768H12.8284V12.8284H15.6768V10.9294H12.8284V8.08101H10.9294V10.9294H8.08101V12.8284H10.9294V15.6768Z"
        fill="currentColor"
      />
    </svg>
  );
}
